const initialState = () => ({
  staff: {
    byId: {},
    ids: []
  },
  business: {},
  locations: {
    byId: {},
    ids: []
  }
})

export default initialState
